__turbopack_context__.v({
  "modalContent": "FolderDeleteModal-module__PEiAYG__modalContent",
});
